// Homepage Mod
var waitlistButtons = document.querySelectorAll('.waitlist-button');

waitlistButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
        // e.preventDefault();
        // code to open Wait.li popup
    });
});

// Variant hack

